<template>
  <v-container>
    <v-dialog 
      v-model = "createCampaignDialog" 
      width="500">
      <v-card class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title
          style="font-size: 28px">
            Rename Campaign
           <v-spacer />
           <v-icon @click="createCampaignDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-campaign
            ref = "addCampaign"
            :put = "campaign"
            @loading = "addButtonLoader = $event"
            @success = "handleAddCampaign">
              <label slot = "before-name" class="black--text" style="font-size: 16px">Campaign Name</label>
          </add-campaign>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createCampaignDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewCampaign">
            Rename
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-layout row wrap class="border-radius-standard px-0 py-0 align-center" align="center">
        <v-flex v-if="campaign">
          <span class="template-title">({{ campaign.name }})
          <v-icon v-if="campaign && campaign.status === 'DRAFT'" @click="createCampaignDialog = true" color="primary">edit</v-icon>
        </span>
        </v-flex>
        <v-spacer/>
        <schedule-campaign
          v-if="campaign"
          :campaign="campaign"
          @success="getCampaignData"
          @updated="getCampaignData"/>
        <v-btn color="black" @click="save" outline>Save for later</v-btn>
        <v-btn color="primary" @click="send" :disabled="campaign && campaign.status === 'SCHEDULED'">Send</v-btn>
      </v-spacer>
    </v-layout>
    <v-layout row wrap class="white border-radius-standard pl-3 py-3">
      <v-flex xs12 lg6 class="px-0 template-msg-editor">
      	<v-flex xs12>
            <div class="title-icon">
              <span
                class="botter-image1-icon white--text text-lg-2 icon-holder primary"
              />
              <span class="title-content">Template Message</span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-select
            	v-model="input.templateId"
            	:items="templateMessagesOptions"
              class="field-width"
            	item-text="text"
            	item-value="value"
              @change="save"
            	outlined />
          </v-flex>
        <template-editor
          v-if="input.templateId"
          v-model="componentsValue"
          ref="templateEditorRef"
          :template-id="input.templateId"
          disable
          show-only
          @info="handleTemplateData">
          	<span slot="title"/>
            <v-flex xs12 slot="header-append">

         <div v-if="input.image">
            <label >Image link</label>
            <v-text-field 
              placeholder = "Image Url" 
              class="field-width"
              outline
              v-model="input.image.value"
               />
          <label>
            Upload Your Image
          </label>
          <image-input 
            :url="input.image.value"
            class="field-width"
            @onImageUpload="input.image.value = $event"/>
        </div>

        <div v-if="input.document">
            <label >Document link</label>
            <v-text-field 
              placeholder = "File URL" 
              outline
              class="field-width"
              v-model="input.document.file_name"
               />
          <label>
            Upload Your Document
          </label>
          <image-input 
            :url="input.document.value"
            type=""
            icon="botter-logo-icon"
            class="field-width"
            @onImageUpload="input.document.file_name = $event">
              <v-icon slot="icon">content_paste</v-icon>
            </image-input>
        </div>

            <p v-if="input.header.length">Header Parameters</p>
            <div v-for="(variable, v) in input.header" :key="variable.attribute">
              <label class="grey--text">Value {{ variable.attribute.split('header_').join('') }}</label>
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('header', v, $event, variable)"
                placeholder="Header"
                class="field-width"
                outline />
            </div>
            <p v-if="input.body.length">Body Parameters</p>
            <div v-for="(variable, v) in input.body" :key="variable.attribute">
              <label class="grey--text">Value {{ variable.attribute.split('body_').join('') }}</label>
              <v-text-field
                placeholder="Body"
                class="field-width"
                @input="handleInputChange('body', v, $event, variable)"
                :value="variable.value"
                outline />
            </div>
            <p v-if="input.footer.length">Footer Parameters</p>
            <div v-for="(variable, v) in input.footer" :key="variable.attribute">
              <label class="grey--text">Value {{ variable.attribute.split('footer_').join('') }}</label>
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('footer', v, $event, variable)"
                placeholder="Footer"
                class="field-width"
                outline />
            </div>
            <p v-if="input.buttons.length">Buttons Parameters</p>
            <div v-for="(variable, v) in input.buttons" :key="variable.attribute">
              <label class="grey--text">Value {{ variable.attribute }}</label>
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('buttons', v, $event, variable)"
                :placeholder="variable.attribute"
                class="field-width"
                outline />
            </div>

            <div v-if="!uploadEnabled && uploadStatus" class="mt-3">
              <label>Upload Your Data</label>
              <uploading-status
                :status="uploadStatus.status"
                :message="uploadStatus.message"
                class="field-width"
                @download-file="downloadTemplate"
                @update-file="uploadAttemp = true"
                @upload-virtual-complete="handleVirtaulSuccess"/>
            </div>
            <div class="mt-3">
            <!-- <label >Your Receivers File URL</label>
            <v-text-field 
              placeholder = "File URL" 
              outline
              class="field-width"
              v-model="receivers.url"
               /> -->
          <label v-if="uploadEnabled">
            Upload Your Data
          </label>
          <div
            v-if="loaders.uploadStatus && uploadEnabled"
            class="mt-3" >
              <uploading-status
                status="inProgress"
                class="field-width"
                @download-file="downloadTemplate"
                @upload-virtual-complete="handleVirtaulSuccess"
                @update-file="uploadAttemp = true"/>
            </div>
          <image-input
            v-if="uploadEnabled"
            :style="{ display: loaders.uploadStatus ? 'hidden' : 'block' }"
            :url="receivers.url"
            :upload-instance="$http_chat"
            :upload-url="`/campaigns/${campaign._id}/upload-receivers-template`"
            :drag-placeholder="null"
            type=".csv, application/vnd.ms-excel, *"
            :icon="null"
            :validation="false"
            class="field-width receivers-uploader"
            @onImageUpload="handleReceiversUploadSuccess"
            @error="handleUploadFailure">
              <div
                slot="placeholder"
                class="px-2 primary--text"
                style="
                  text-align: left;
                  display: flex;
                  align-items: center;">
                <span class="botter-excel-icon " style="font-size: 32px;" />
                <span class="px-2">To customize data based on user, drag your file here</span>
              </div>
            </image-input>
            <a
                v-if="uploadEnabled"
                color = "primary"
                style="text-decoration: underline; font-size: 12px;"
                class="pa-0 ma-0 download-template-text"
                flat
                @click="downloadTemplate">
                <b>Download File Template</b>
            </a>
        </div>

          </v-flex>
          </template-editor>
      </v-flex>
      <v-flex v-if="!loaders.campaign" xs12 lg6 class="py-5">
      	<v-layout row wrap justify-center align="center">
      		<v-flex xs12 style="display: flex; justify-content: center">
      			<template-viewer
              :loading="!loaders.campaign"
              :init="appliedVariables"
              @components-format="formatCompnentsInput"
              :params="input"
              :disabled="!input.templateId || !input.templateId.length"/> 
      		</v-flex>
      	</v-layout>
      </v-flex>
    </v-layout>
    <receivers-crud v-if="currentCampaign" ref="receiversRef" />
  </v-container>
</template>

<script>
import TemplateMessageButtons from '@/components/campaign-manager/template-message-editor/TemplateMessageButtons'
import TemplateViewer from '@/components/campaign-manager/template-message-editor/TemplateViewer'
import TemplateEditor from '@/components/campaign-manager/template-message-editor/TemplateEditor'
import ReceiversCrud from '@/components/campaign-manager/receivers-crud'
import imageInput from '@/components/block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone'
import ScheduleCampaign from '@/components/campaign-manager/campaigns-crud/ScheduleCampaign'
import UploadingStatus from '@/components/campaign-manager/campaigns-crud/UploadingStatus'
import AddCampaign from '@/components/campaign-manager/campaigns-crud/AddCampaign.vue'
import fileDownload from 'js-file-download'
export default {
  name: 'SingleCampaing',
  components: {
  	TemplateMessageButtons,
  	TemplateViewer,
    TemplateEditor,
    imageInput,
    ReceiversCrud,
    ScheduleCampaign,
    UploadingStatus,
    AddCampaign
  },
  data() {
    return {
      campaign: null,
      templateData: null,
      componentsValue: [],
      uploadStatus: null,
      uploadAttemp: false,
      loaders: {
        uploadStatus: false,
      },
      input: {
      	templateId: null,
        campaign: false
      },
      receivers: {
        url: '',
        users: null
      },
      formattedComponents: {},
      input: {
        header: [],
        body: [],
        footer: [],
        image: null,
        document: null,
        url: [],
        phoneNumber: [],
        buttons: [],
      },
      paramtersInput: [],
      addButtonLoader: false,
      createCampaignDialog: false,
    }
  },
  mounted() {
    this.getTemplateMessages()
    this.getCampaignData()
    this.getReceivers()
    this.checkUploadStatus();
  },
  computed: {
    currentCampaign() {
      return this.$store.state.campaigns.selectedCampaign
    },
    uploadEnabled() {
      return !this.loaders.uploadStatus && (this.uploadAttemp || (!this.uploadStatus || this.uploadStatus.status === 'Not-Uploaded-Yet'))
    },
    editedParams() {
      return Object.values(this.$_.pickBy( this.input, i => i)).filter(p => {
        if(Array.isArray(p)) {
          return Boolean(p.length)
        } else return p.constructor === Object
      }).flat()
    },
    templateMessagesOptions() {
      if(!this.campaign) return []
    	return this.$store.state.campaigns.templateMessages
      .filter(t => t.status === 'APPROVED' && t.app.id === this.campaign.app.id)
      .map(t => ({ text: `${t.name} (${t.status})`, value: t._id }))
    },
    appliedVariables() {
      if(!this.componentsValue || !this.componentsValue.length) {
        return []
      }
      let result = this.$_.cloneDeep(this.componentsValue)
      // header
      const headerIndex = result.findIndex(i => i.type === 'HEADER')
      if(headerIndex !== -1) {
        // text
        if(result[headerIndex].format === 'TEXT') {
          result[headerIndex].text = result[headerIndex].text.split(' ').map((i => {
            if(!new RegExp(/{{\w}}/).test(i)) return i
            let slugIndex = this.input.header.findIndex(h => h.attribute === `header_${i}`)
            if(slugIndex !== -1 && this.input.header[slugIndex].value.length) {
              return this.input.header[slugIndex].value
            } return i
          })).join(' ')
        }

        if(result[headerIndex].format === 'IMAGE') {
          result[headerIndex].url = this.input.image ? this.input.image.value : ''
        }
        if(result[headerIndex].format === 'DOCUMET') {
          result[headerIndex].url = this.input.document ? this.input.document.value : ''
        }
      }

      // body
      const bodyIndex = result.findIndex(i => i.type === 'BODY')
      if(bodyIndex !== -1) {
        // text
        
          result[bodyIndex].text = result[bodyIndex].text.split(' ').map((i => {
            if(!new RegExp(/{{\w}}/).test(i)) return i
            let slugIndex = this.input.body.findIndex(h => h.attribute === `body_${i}`)
            if(slugIndex !== -1 && this.input.body[slugIndex].value.length) {
              return this.input.body[slugIndex].value
            } return i
          })).join(' ')
        }

         // footer
      const footerIndex = result.findIndex(i => i.type === 'FOOTER')
      if(footerIndex !== -1) {
        // text
        
          result[footerIndex].text = result[footerIndex].text.split(' ').map((i => {
            if(!new RegExp(/{{\w}}/).test(i)) return i
            let slugIndex = this.input.footer.findIndex(h => h.attribute === `footer_${i}`)
            if(slugIndex !== -1 && this.input.footer[slugIndex].value.length) {
              return this.input.footer[slugIndex].value
            } return i
          })).join(' ')
        }
      



      return result
    }
  },
  methods: {
    handleUploadFailure() {
      this.loaders.uploadStatus = false;
      this.uploadStatus = { status: 'Failed' }
    },
    handleInputChange(context, attr, event, val) {
      // console.log(event, attr, context)
      this.$set(this.input[context], attr, { ...val ,value: event})
    },
    addNewCampaign() {
      if (this.$refs.addCampaign) this.$refs.addCampaign.submit()
    },
    handleAddCampaign(e) {
      this.createCampaignDialog = false
    },
    formatCompnentsInput(e) {
      this.formattedComponents = e
      // this.input.header = this.getKeyVariables('header')
      // this.input.body = this.getKeyVariables('body')
      // this.input.footer = this.getKeyVariables('footer')
    },
    getTextVariables(text) {
      return text.split(' ').filter( i => new RegExp(/{{\w}}/).test(i) )
    },
    getKeyVariables(key) {
      const result = {}
      if(key === 'header') {
        if(this.formattedComponents.header && this.formattedComponents.header.text) {
          const textVariables = this.getTextVariables(this.formattedComponents.header.text)
          let i
          for(i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = ''
          }
        }
      }
      else if(key === 'body') {
        if(this.formattedComponents.body && this.formattedComponents.body.text) {
          const textVariables = this.getTextVariables(this.formattedComponents.body.text)
          let i
          for(i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = ''
          }
        }
      }
      else if(key === 'footer') {
        if(this.formattedComponents.footer && this.formattedComponents.footer.text) {
          const textVariables = this.getTextVariables(this.formattedComponents.footer.text)
          let i
          for(i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = ''
          }
        }
      }
      return result
    },
  	getTemplateMessages() {
      this.$store.dispatch('templatemessages/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
      this.$store.dispatch('templatesettings/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    mixParams(template, campaign) {
      let i
      let index
      const params = []
      for(i = 0; i < template.length; i += 1) {
        index = campaign.findIndex(row => template[i].attribute === row.attribute && row.value.length)
        if(index !== -1) {
          params.push(campaign[index])
        } else {
          params.push(template[i])
        }
      }
      return params
    },
    handleTemplateData(e) {
      if(!e) return
      this.templateData = e
      const params = this.mixParams(e.parameters, this.campaign.parameters);
      this.paramtersInput = this.$_.cloneDeep(params)
      this.input.image = this.paramtersInput.filter(p => p.attribute === 'image').length ? this.paramtersInput.filter(p => p.attribute === 'image')[0] : null
      this.input.document = this.paramtersInput.filter(p => p.attribute === 'document').length ? this.paramtersInput.filter(p => p.attribute === 'document')[0] : null
      this.input.header = this.paramtersInput.filter(p => p.attribute.startsWith('header_'))
      this.input.body = this.paramtersInput.filter(p => p.attribute.startsWith('body_'))
      this.input.footer = this.paramtersInput.filter(p => p.attribute.startsWith('footer_'))
      this.input.buttons = this.paramtersInput.filter(p => p.attribute.startsWith('url_'))
    },
    getCampaignData() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.get(`/campaigns/${this.$route.params.id}`).then(res => {
        // console.log('ca', res.data)
        this.campaign = res.data.data
        if(['DRAFT', 'CANCELED', 'SCHEDULED'].indexOf(this.campaign.status) === -1) {
          this.$router.push(`/campaigns/${this.campaign._id}/overview`)
          this.$store.dispatch('setLoader', false)
          return
        }
        this.$store.commit('campaigns/select', res.data.data)
        if(res.data.data.message) {
          this.input.templateId = res.data.data.message.template_msg_id
          this.handleTemplateData()
        }
        this.$store.dispatch('setLoader', false)
      }).catch(()=> {
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    async getReceivers() {
      // this.$store.dispatch('setLoader', true)
      // try {
      //   const response = await this.$http_chat.get(`/campaigns/${this.$route.params.id}/receivers`)
      //   this.receivers.users = response.data.data
      //   this.$store.dispatch('setLoader', false)
      // } catch(err) {
      //   this.$store.dispatch('setErrorMessage', true)
      //   this.$store.dispatch('setLoader', false)
      // }
      if(this.$refs.receiversRef)
      this.$refs.receiversRef.getReceivers(false)
    },
  	async save() {
      try {
        this.loaders.campaign = true
        await this.saveTemplateMessage()
        await this.saveParams()
        this.getCampaignData()
        this.loaders.campaign = false
      } catch(err) {
        this.loaders.campaign = false
        this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
      }
    },
    async send() {
      try {
        await this.sendCampaign()
        // this.getCampaignData()
        this.$router.push('/campaigns/all')
      } catch(err) {
        // console.log(err)
        this.$store.dispatch('setLoader', false)
      }
    },
    async sendCampaign() {
      try {
        await this.$http_chat.post(`/campaigns/${this.$route.params.id}/send`)
        return true
      } catch (err) {
        let msg =
        err.response && err.response.data && err.response.data.message ? err.response.data.message.error : 'Sending Failed'
              this.$store.dispatch('setErrorMessage', msg)
        throw err
      }
    },
    async saveTemplateMessage() {
      try {
        await this.$http_chat.put(`/campaigns/${this.$route.params.id}/message`, {
          type: 'template',
          template_msg_id: this.input.templateId
        })
        return true
      } catch (err) {
        throw err
      }
    },
    async saveParams() {
      try {
        await this.$http_chat.put(`/campaigns/${this.$route.params.id}/parameters`, { parameters: this.editedParams })
      } catch (err) {
        throw err
      }
    },
    handleReceiversUploadSuccess(e) {
      this.receivers.url = e
      this.uploadAttemp = false
      this.uploadStatus = { status : 'Inprogress' }
      this.checkUploadStatus();
      this.getReceivers()
    },
    downloadTemplate() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.get(`/campaigns/${this.$route.params.id}/download-receivers-template`)
      .then(res => {
        this.$store.dispatch('setLoader', false)
        fileDownload(res.data, 'template.csv')
        this.uploadAttemp = true
      })
      .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    async checkUploadStatus() {
      // handle Virtual Success
      if(this.uploadStatus && this.uploadStatus.status === 'Virtual') {
        this.uploadStatus.status = 'Success'
        return;
      }
      try {
        const status = await this.getUploadStatus();
        if(
            status
            && status.status !== 'Success'
            && status.status !== 'Not-Uploaded-Yet' 
            && status.status !== 'Failed'
          ) {
          setTimeout(()=>{
            this.checkUploadStatus();
          }, 10000)
          if(status.status === 'Inprogress') {
            this.uploadStatus = status
          }
        } else {
          this.uploadStatus = status
          this.getReceivers();
        }
      } catch(err) {
        console.log(err)
        // this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
        this.loaders.uploadStatus = false;
        this.uploadStatus = { status: 'Failed' }
      }
      
    },
    handleVirtaulSuccess() {
      this.uploadStatus.status = 'Virtual';
      this.uploadAttemp = true;
    },
    async getUploadStatus() {
      try {
        // if(this.campaign && this.campaign.status === 'DRAFT') {
        //   return;
        // }
        // this.$store.dispatch('setLoader', true)
        this.loaders.uploadStatus = true;
        const res = await this.$http_chat.get(`/campaigns/${this.$route.params.id}/uploading-status`)
        // this.$store.dispatch('setLoader', false)
        // this.uploadStatus = res.data.data
        this.loaders.uploadStatus = false;
        return res.data.data;
      }
      catch(err) {
          // console.log(err) 
          this.$store.dispatch('setLoader', false)
          this.loaders.uploadStatus = false;
          if(err.response && err.response.status === 400) {
            this.uploadStatus = { status: 'Failed' }
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
          return false;
      }
    }

  }
}
</script>

<style lang="scss">
.header-col {
}
.receivers-uploader > .image-uploader {
    max-width: 100%;
    height: 100px;
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #F4F5F9;
    overflow: hidden;
}
.header-option {
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 8px;
  border: 1px dashed #ccc;
  background-color: #f4f5f9;
  display: block;
}
.header-content {
  width: 100px;
  margin-left: -3px;
}
.title-icon {
  .icon-holder {
    border-radius: 8px;
    padding: 3px;
  }
  .title-content {
    padding-left: 5px;
    vertical-align: super;
    font-size: 16px;
  }
}
.template-subtitle {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
.button-option {
	border: 1px solid #372fac;
	border-radius: 8px;
	padding: 10px 5px;
	width: 30%;
	justify-content: center;
	cursor: pointer;
	margin-left: 0px;
	margin-right: 4px;
}
.buttons-radio-gp {
	.v-input__control {
		width: 100%;
	}
}
.field-width {
	width: 450px;
}
.template-msg-editor {
	border-right: 2px dashed #f4f5f9;
}
.template-title {
  font-weight: bold;
  font-size: 22px;
}
.download-template-text:hover {
  background-color: white !important;
}
</style>
